exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vb-container[data-v-5a9cf520]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.vb-container [data-v-5a9cf520]:not(:first-child){margin-top:10px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookContainer.vue"],"names":[],"mappings":"AACA,+BACE,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACtB,AACD,kDACI,eAAiB,CACpB","file":"VirtualBookContainer.vue","sourcesContent":["\n.vb-container[data-v-5a9cf520] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.vb-container *[data-v-5a9cf520]:not(:first-child) {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a9cf520","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VirtualBookViewer/VirtualBookContainer.vue
// module id = 1361
// module chunks = 9